import React, { MouseEventHandler, useCallback } from 'react';
import {
  ButtonGroupButtonContext,
  ButtonGroupContext,
  IconButton as MuiIconButton,
  capitalize,
  getIconButtonUtilityClass,
} from '@mui/material';
import clsx from 'clsx';
import { IconButtonProps, iconButtonClasses } from './types';
import { SpinningLoading } from '../animations';

export const IconButton = React.forwardRef(
  (props: IconButtonProps, ref: React.RefObject<HTMLButtonElement>) => {
    const {
      variant: groupVariant,
      className: groupClassName,
      size: groupSize,
    } = React.useContext(ButtonGroupContext);
    const positionClassName = React.useContext(ButtonGroupButtonContext);

    const {
      variant, size = groupSize,
      className, selected, onChange, loading, children, ...baseProps
    } = props;

    const handleClick: MouseEventHandler<HTMLButtonElement> = useCallback((e) => {
      const { onClick, value } = props;

      if (selected !== undefined && onChange) {
        onChange(e, value);
      }

      if (onClick) {
        onClick(e);
      }
    }, [onChange, props, selected]);

    return (
      <MuiIconButton
        className={
          clsx(
            className,
            groupClassName,
            positionClassName,
            getIconButtonUtilityClass(`variant${capitalize(variant ?? groupVariant ?? 'text')}`),
            {
              [iconButtonClasses.selected]: selected,
            },
          )
        }
        onClick={handleClick}
        ref={ref}
        size={size}
        {...baseProps}
      >
        {loading ? (
          <SpinningLoading
            sx={{
              width: size === 'large' ? 20 : 16,
              height: size === 'large' ? 22 : 20,
            }}
          />
        ) : (
          children
        )}
      </MuiIconButton>
    );
  },
);
